<template>
  <div class="wrapper">
    <div class="header maxwidth">
      <img src="@/assets/logo.png" />
      <ul>
        <li v-for="(item, index) in menu" :key="index">{{ item.name }}</li>
      </ul>
    </div>
    <img src="@/assets/top_index_bg.jpg" class="top_index_bg" />
    <div class="box  maxwidth">
      <h6 class="tit">主要产品</h6>
      <el-row class="box-product">
        <el-col :span="8">
          <img src="@/assets/product1.png" class="product_bg" />
        </el-col>
        <el-col :span="8">
          <img src="@/assets/product2.png" class="product_bg" />
        </el-col>
      </el-row>
    </div>
    <div class="box maxwidth">
      <h6 class="tit">经典案例</h6>
      <ul class="box-case">
        <li v-for="(item, index) in cases" :key="index">
          <img :src="require('@/assets/pic_home_case_' + index + '.png')" />
          <p>
            <b>{{ item.court }}</b>
          </p>
          <p>{{ item.content }}</p>
          <span class="btn bluebtn" @click="goto">查看详情</span>
        </li>
      </ul>
    </div>
    <div class="footer">
      <div class="maxwidth">
        <!-- <img src="@/assets/logo_white.png" class="logo" /> -->
        <div class="main">
          <ul>
            <li v-for="(item, index) in footerDatas" :key="index">
              <h6>{{ item.type }}</h6>
              <p v-for="(item1, index1) in item.childs" :key="index1">{{ item1.name }}</p>
            </li>
          </ul>
          <div class="rightbox">
            <p><b>咨询电话</b><b class="tel">0592-5513676</b></p>
            <p class="email">ysw@dafengtech.com</p>
            <div class="ewms">
              <p><img src="@/assets/ewm_wx.png" />微信公众号</p>
              <!-- <p><img src="@/assets/ewm_sw.png" />商务合作</p> -->
            </div>
          </div>
        </div>
        <p class="copy" @click="goto1">{{ icpNumber }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Index',
  data() {
    return {
      menu: [{ id: 0, name: '智创源产品' }, { id: 1, name: '经典案例' }, { id: 2, name: '关于我们' }],
      cases: [
        { id: 0, court: '南安市人民法院', content: '2022年新年伊始，由远峰创新提供“一站式”智慧诉讼服务产品的南安法院正式投入使用。按照最高人民法院和省高院对两个一站式...' },
        { id: 1, court: '浦城县人民法院', content: '为更好的满足人民群众的多元司法需求，聚焦群众“急难愁盼”问题，为群众提供更加高效、便捷的诉讼服务，2023年2月16日，由......' },
        { id: 2, court: '晋江市人民法院', content: '2022年开春，由远峰创新提供全流程诉讼服务产品的晋江市人民法院正式投入使用，新建成的晋江市人民法院诉讼服务中心使用面积...' },
      ],
      footerDatas: [
        {
          type: '产品',
          childs: [{ name: '在线诉讼平台' }, { name: '东法智慧诉服' }, { name: '法信智校' }, { name: '法院人脸应用' }],
        },
        {
          type: '经典案例',
          childs: [{ name: '晋江市' }, { name: '南安市' }, { name: '厦门市' }],
        },
        {
          type: '智慧诉服',
          childs: [{ name: '诉讼服务智慧舱' }, { name: '智慧导诉' }, { name: '法律服务' }, { name: '智能文书' }, { name: '自助立案' }, { name: '自助查询' }, { name: '自助查询' }],
        },
      ],
    };
  },

  computed: {
    icpNumber() {
      const host = window.location.hostname;
      if (host.includes('dafengtech.com')) return '闽ICP备2022010915号-2';
      if (host.includes('xmzcy.com.cn')) return '闽ICP备2022010915号-3';
      return '闽ICP备2022010915号-2';
    },
  },
  created() {},
  mounted() {},
  methods: {
    goto() {
      window.open('https://mp.weixin.qq.com/s/Y-wjHV7WbVLd2UZbDVaeoA', '_blank');
    },
    goto1() {
      window.open('https://beian.miit.gov.cn', '_blank');
    },
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 80px;
    img {
      height: 40px;
    }
    ul li {
      display: inline-block;
      margin-left: 20px;
      font-size: 14px;
      color: #222;
      cursor: pointer;
    }
  }
  .footer {
    background: #272727;
    padding: 34px 0 10px;
    .logo {
      height: 42px;
    }
    .main {
      display: flex;
      justify-content: space-between;
      color: #fff;
      font-size: 14px;
      padding-top: 30px;
      ul {
        width: 45%;
        display: flex;
        li {
          flex: 1;
          color: #888;
          h6 {
            color: #fff;
            font-weight: bold;
            font-size: 16px;
          }
          p {
            margin-top: 10px;
            font-size: 14px;
            cursor: pointer;
          }
        }
      }
      .rightbox {
        width: 25%;
        line-height: 2;
        b {
          font-size: 16px;
          display: block;
          &.tel {
            font-size: 24px;
          }
        }
        p.email {
          color: #888;
        }
        .ewms {
          color: #888;
          font-size: 14px;
          margin-top: 50px;
          p {
            display: inline-block;
            text-align: center;
          }
          img {
            width: 100px;
            display: block;
            margin-bottom: 10px;
          }
        }
      }
    }
    .copy {
      text-align: center;
      color: #888888;
      font-size: 12px;
      padding-top: 20px;
      cursor: pointer;
    }
  }
  .top_index_bg {
    width: 100%;
    margin-bottom: 30px;
  }
}
.box {
  margin: 40px auto;
  h6.tit {
    padding: 10px 0 20px;
    font-weight: bold;
    font-size: 24px;
  }
  .box-product {
    display: flex;
    .el-col {
      position: relative;
      margin-right: 40px;
      cursor: pointer;
      .product_bg {
        max-width: 100%;
      }
    }
  }
  .box-case {
    margin: 0 -1%;
    li {
      display: inline-block;
      width: 48%;
      margin: 0 1% 1%;
      background: #f5f5f5;
      overflow: hidden;
      padding-bottom: 24px;
      border-radius: 9px;
      img {
        width: 100%;
        margin-bottom: 10px;
      }
      b {
        font-size: 18px;
        color: #222;
      }
      p {
        font-size: 14px;
        padding: 10px 24px 0;
        line-height: 2;
        color: #888888;
      }
      .btn {
        float: right;
        margin-right: 24px;
        margin-top: 24px;
      }
    }
  }
}
</style>
